import React, {useMemo} from "react";
import {Link} from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_helpers";
import {useHtmlClassService} from "../../_core/MetronicLayout";

export function HeaderMobile() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getStickyLogo(),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      headerMenuSelfDisplay:
        objectPath.get(uiService.config, "header.menu.self.display") === true,
      headerMobileCssClasses: uiService.getClasses("header_mobile", true),
      headerMobileAttributes: uiService.getAttributes("header_mobile")
    };
  }, [uiService]);

  return (
    <div
      id="kt_header_mobile"
      className={`header-mobile align-items-center ${layoutProps.headerMobileCssClasses}`}
      {...layoutProps.headerMobileAttributes}
    >
      {layoutProps.asideDisplay && (
        <button className="btn p-0 burger-icon" id="kt_aside_mobile_toggle">
          <span/>
        </button>
      )}

      <Link to="/" className="text-white">
        <span className="font-size-h1 text-white font-weight-bolder">
          Lullu
        </span>
      </Link>

      <div className="d-flex align-items-center">
        <button
          className="btn btn-hover-text-primary p-0"
          id="kt_header_mobile_topbar_toggle"
        >
          <span className="svg-icon svg-icon-xl">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}/>
          </span>
        </button>
      </div>
    </div>
  );
}
